import classNames from 'classnames';

export interface PageDetailContentProps {
  className?: string;
  align?: 'left' | 'center' | 'right';
}

export function PageDetailContent({
  children,
  className,
  align = 'center',
}: React.PropsWithChildren<PageDetailContentProps>) {
  return (
    <main className={classNames(className, '-mt-14')}>
      <div
        className={classNames(
          'px-4 py-4',
          align === 'left' && 'mr-auto',
          align === 'center' && 'mx-auto',
          align === 'right' && 'ml-auto',
        )}
      >
        {children}
      </div>
    </main>
  );
}

export default PageDetailContent;
